import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

import { CALENDAR } from '@constants/routes';

const CalendarPage = lazy(
  () => import('@features/calendar/pages/calendar/Calendar')
);

export const CalendarRoutes: RouteObject[] = [
  {
    path: CALENDAR.CALENDAR,
    element: <CalendarPage />
  }
];

export default CalendarRoutes;
